import React from 'react';
import styles from './input.module.css';

class Input extends React.Component {
  constructor(props) {
    super(props);
    this.state = { value: this.props.value }
  }

  handleValue = (e) => {
    let typeNumber;
    typeNumber = e.target.getAttribute('data-number')
    if (typeNumber) { e.target.value = e.target.value.replace(/[^0-9]/g, ''); }
    this.setState({value: e.target.value});
  }

  handleValidate = (e) => {
    let val;
    let length;
    let required;
    let dataError;
    let errorMessage;
    let underInput;
    val = e.target.value;
    length = e.target.getAttribute("data-length");
    required = e.target.getAttribute("data-required");
    dataError = e.target.getAttribute("data-error");
    if(this.props.underinput) {
      underInput = this.props.underinput
    }
    else {
      underInput = ''
    }

    if (length) {
      if (length.includes("|")) {
        var firstLengthValue = parseInt(length.substr(0, length.indexOf('|')), 10);
        var seconfLengthValue = parseInt(length.split('|')[1], 10);
        if ((val.length !== firstLengthValue) && (val.length !== seconfLengthValue)) {
          e.target.className += "  invalid-input";
          if (dataError) {
            errorMessage = "<span class='error-message'>" + dataError + "</span>";
          }
          else {
            errorMessage = "<span class='error-message'>" + firstLengthValue + " или " + seconfLengthValue + " символов</span>";
          }
          e.target.nextSibling.innerHTML = errorMessage;
        }
        else {
          e.target.classList.remove("invalid-input");
          e.target.nextSibling.innerText = underInput;
        }
      }
      else {
        if (parseInt(length, 10) !== val.length) {
          e.target.className += " invalid-input";
          if (dataError) {
            errorMessage = "<span class='error-message'>" + dataError + "</span>";
          }
          else {
            errorMessage = "<span class='error-message'>Длина поля " + length + " символов</span>";
          }
          e.target.nextSibling.innerHTML = errorMessage;
        }
        else {
          e.target.classList.remove("invalid-input");
          e.target.nextSibling.innerText = underInput;
        }
      }
    }
    else {
      if ((required === "true") && val.length < 1) {
        e.target.className += " invalid-input";
        errorMessage = "<span class='error-message'>Обязательное поле</span>";
        e.target.nextSibling.innerHTML = errorMessage;
      }
      else {
        e.target.classList.remove("invalid-input");
        e.target.nextSibling.innerText = underInput;
      }
    }
  }

  render() {
    return (
      <div>
        <div className={styles.label}>{this.props.label}</div>
        <input type="text" className={`${styles.input} ${this.props.className}`}
               onChange={this.handleValue}
               value={this.state.value}
               onInput={this.handleValidate} id={this.props.id}
               name={this.props.name} placeholder={this.props.placeholder}
               maxLength={this.props.maxlength} data-length={this.props.length}
               data-error={this.props.error} length={this.props.length}
               data-required={this.props.required} disabled={this.props.disabled}
               data-number={this.props.dataNumber}
               onBlur={this.props.onChange}
        />
        <div className={styles.underinput}>{this.props.underinput}</div>
      </div>
    )
  }
}

export default Input;